module.exports = __webpack_public_path__ + "static/media/buanderie.c5150099.jpg";